import { atom, selector } from "recoil"
import { draftSelector } from "src/recoil/selectors/contact/draftSelector"
import { templateSelector } from "src/recoil/selectors/contact/templateSelector"
import { existingContactDetailSelector } from "src/recoil/selectors/contact/create/existingContactDetailSelector"
import { reservedSelector } from "src/recoil/selectors/contact/reservedSelector"

const initialState = false

const initialStateSelector = selector({
  key: "atoms/contact/create/isPublishAnswersToMembersState_initialState",
  get: ({ get }) => {
    const contact = get(existingContactDetailSelector)
    const contactValue =
      contact?.contactType === "Attendance" ||
      contact?.contactType === "Survey" ||
      contact?.contactType === "ScheduleAdjustment"
        ? contact.isPublishAnswersToMembers
        : undefined
    const reserved = get(reservedSelector)
    const reservedValue =
      reserved?.contactType === "Attendance" ||
      reserved?.contactType === "Survey" ||
      reserved?.contactType === "ScheduleAdjustment"
        ? reserved.isPublishAnswersToMembers
        : undefined
    const template = get(templateSelector)
    const draft = get(draftSelector)
    return contactValue ?? reservedValue ?? (template ?? draft)?.isPublishAnswersToMembers ?? initialState
  },
})

export const isPublishAnswersToMembersState = atom({
  key: "atoms/contact/create/isPublishAnswersToMembersState",
  default: initialStateSelector,
})
